import { UiIcon } from '../../../../components/icon/index.mjs';
import { UiLoadingPropsOption } from './loading.mjs';
import { defineComponent } from 'vue';
import { useComposable } from './composable.mjs';

var _sfc_main = defineComponent({
  name: "UiLoading",
  props: UiLoadingPropsOption,
  components: { UiIcon },
  setup(define) {
    const { computeds, methods, refs } = useComposable(define);
    return { ...computeds, ...methods, ...refs };
  }
});

export { _sfc_main as default };
//# sourceMappingURL=loading.vue2.mjs.map
